var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.444,
    height: 21.043,
    viewBox: "0 0 18.444 21.043",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "share_1_",
    "data-name": "share (1)",
    d: "M14.164,13.482a3.273,3.273,0,0,0-2.426,1.074l-5.4-3.345a3.268,3.268,0,0,0,0-2.379l5.4-3.345a3.28,3.28,0,1,0-.63-1.016l-5.4,3.345a3.281,3.281,0,1,0,0,4.412l5.4,3.345a3.28,3.28,0,1,0,3.056-2.091Zm-2.084-10.2a2.084,2.084,0,1,1,2.084,2.084A2.087,2.087,0,0,1,12.079,3.281Zm-8.8,8.825a2.084,2.084,0,1,1,2.084-2.084A2.087,2.087,0,0,1,3.281,12.106Zm8.8,4.656a2.084,2.084,0,1,1,2.084,2.084A2.087,2.087,0,0,1,12.079,16.762Zm0,0",
    transform: "translate(0.5 0.5)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareWhite);
export default __webpack_public_path__ + "static/media/ShareWhite.32904d1fb29ed288c35b4b20c66d5523.svg";
export { ForwardRef as ReactComponent };